import { createAction } from '@reduxjs/toolkit';

import type { RootState as ProjectionState } from '@polyai/stream/store';
import { sliceReducers } from '@polyai/stream/store';

import type { RootState } from 'reduxStore';

const PREFIX = 'projection';

export const hydrateProjection = createAction<{
  projection: ProjectionState;
  sequenceId: number;
}>(`${PREFIX}/hydrate`);

export const rollBackProjection = createAction<{
  projection: ProjectionState;
}>(`${PREFIX}/rollBack`);

export const applyHydration = (
  state: RootState,
  projection: ProjectionState,
) => {
  const keys = Object.keys(sliceReducers) as Array<keyof typeof sliceReducers>;

  const result = { ...state };
  for (const key of keys) {
    if (key in state && key in projection) {
      // Only replace if the reference changed. Unchanged slices keep their
      // original reference so selectors subscribed to them don't re-evaluate.
      if (
        (state[key as keyof RootState] as unknown) !==
        (projection[key] as unknown)
      ) {
        result[key] = projection[key] as any;
      }
    }
  }
  return result;
};
